import React, { Component } from 'react'
import { graphql } from 'gatsby'

import Seo from '../components/seo'

import RenderBlock from '../utils/render-block'

class PageTemplate extends Component {

  render() {
    const { wpPage, wp } = this.props.data

    const jsonLd = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: wpPage.title,
      headline: wpPage.title,
      description: wpPage.seo?.metaDesc,
      url: wpPage.uri,
      image: wpPage.seo?.opengraphImage?.localFile?.childImageSharp?.gatsbyImageData?.images?.fallback?.src || wp.seo.schema?.logo?.sourceUrl,
      datePublished: wpPage.date,
      publisher: {
        '@type': 'Organization',
        name: 'Cobden Hayson',
        url: 'https://ch.com.au'
      }
    };

    return (
      <>
        <Seo bodyClass={`page-template page-template--${wpPage.slug}`} {...wpPage.seo} jsonLd={jsonLd} />
        { wpPage.acf?.contentBlocks?.map((el, i) => RenderBlock(el.fieldGroupName?.replace('page_Acf_ContentBlocks_', ''), el, i))  }
      </>
    )
  }
}

export const pageQuery = graphql`
  query PageTemplateQuery ($id: String!) {
    wpPage(id: {eq: $id}) {
      title
      slug
      uri
      date
      seo {
        ...WpSeo
      }
      acf {
        contentBlocks {
          ... on WpPage_Acf_ContentBlocks_Blog {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_HomeBanner {
            fieldGroupName
            title
            video
          }
          ... on WpPage_Acf_ContentBlocks_TitleContentImageBlocks {
            fieldGroupName
            title
            items {
              title
              content
              button {
                title
                url
              }
              widerContent
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 1000
                    )
                  }
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_CardBlocks {
            fieldGroupName
            items {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 800
                    )
                  }
                }
              }
              title
              content
            }
          }
          ... on WpPage_Acf_ContentBlocks_LatestNews {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_LatestCaseStudies {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_OfficeMap {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_TitleStats {
            fieldGroupName
            title
            content
            stats {
              value
              label
            }
          }
          ... on WpPage_Acf_ContentBlocks_EmergencyTrades {
            fieldGroupName
            title
            items {
              image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(
                      width: 600
                    )
                  }
                }
              }
              title
              content
            }
          }
          ... on WpPage_Acf_ContentBlocks_Roles {
            fieldGroupName
            title
            content
            roles {
              title
              jobs {
                hide
                position
                office
                content
                leftCol
                rightCol
              }
              footerContent
              footerButton {
                url
                title
              }
            }
            
          }
          ... on WpPage_Acf_ContentBlocks_Enquiry {
            fieldGroupName
            title
            content
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Contact {
            fieldGroupName
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_RegisterForAlerts {
            fieldGroupName
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_Quote {
            fieldGroupName
            quote
          }
          ... on WpPage_Acf_ContentBlocks_Appraisal {
            fieldGroupName
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
          }
          ... on WpPage_Acf_ContentBlocks_VideoBanner {
            fieldGroupName
            halfHeight
            withinGrid
            video
            mobileVideo
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
            withinGrid
          }
          ... on WpPage_Acf_ContentBlocks_ImageBanner {
            fieldGroupName
            halfHeight
            withinGrid
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
            withinGrid
          }
          ... on WpPage_Acf_ContentBlocks_AgentsHeader {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_PropertyArchive {
            fieldGroupName
            title
            type
          }
          ... on WpPage_Acf_ContentBlocks_PropertiesShowcase {
            fieldGroupName
            title
          }
          ... on WpPage_Acf_ContentBlocks_Agents {
            fieldGroupName
          }
          ... on WpPage_Acf_ContentBlocks_Upcoming {
            fieldGroupName
            title
            type
          }
          ... on WpPage_Acf_ContentBlocks_BasicPage {
            fieldGroupName
            title
            content
          }
          ... on WpPage_Acf_ContentBlocks_ImageSubscribe {
            fieldGroupName
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(
                    width: 1500
                  )
                }
              }
            }
            imageTitle
            imageButton {
              url
              title
            }
            title
          }
          ... on WpPage_Acf_ContentBlocks_EmbeddableContent {
            fieldGroupName
            markup
          }
        }
      }
    }
    wp {
      seo {
        schema {
          logo {
            sourceUrl
          }
        }
      }
    }
  }
`

export default PageTemplate